import './JxLabel.css';

/**
 * JxLabel — themed text label.
 * Pure painter, no state, no logic.
 *
 * @param {string} text
 * @param {'default'|'muted'|'accent'} variant
 */
export default function JxLabel({ text, variant = 'default', className = '', ...rest }) {
    return (
        <span className={`jx-label jx-label-${variant} ${className}`} {...rest}>
            {text}
        </span>
    );
}
